export default __webpack_public_path__ + "static/media/logo_galicia.dab01d11.png";